import React, { useState } from 'react';
import {
  ButtonContainer,
  HeaderContainer,
} from '../../../common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { AppHeader } from '../../../common/sharedComponents/AppHeader';
import {
  CalendarIconContainer,
  InputContainer,
  InputContainerDatePiker,
  StyledTextLabel,
} from '../../MyAudit/MyAuditAssign/styled.myAuditAssign';
import { Body5, Headline2, Headline4 } from '../../../common/typography';
import DatePicker from 'react-datepicker';
import { SearchBox } from '../../../common/sharedComponents/SearchBox';
import { DatePickerWrapper } from '../../../common/sharedStyledComponents/Datepicker.styled';
import {
  castSelectedDateWithoutConversion,
  convertUTCDateDisplay,
} from '../../../../helpers/dates';
import { CloseCircleDark } from '../../../common/icons/CloseCircleDark';
import { Calendar } from '../../../common/icons/Calendar';
import { ErrorValidation } from '../../../common/sharedComponents/ErrorValidation';
import { TextInput } from '../../../common/sharedComponents/TextInput';
import { TextArea } from '../../../common/sharedComponents/TextArea';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import { ButtonLarge } from '../../../common/sharedComponents/buttons/ButtonLarge';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSearchUser } from '../../../common/hooks/useSearchUser';
import { ISelectedOption } from '../../../@types/searchBox';
import {
  filterOptions,
  handleOptionClickUtil,
} from '../../../common/sharedComponents/SearchBox/utils';

import { getItem, setItem } from '../../../../utils/localStorage';
import { ISelfAssessmentCreation } from '../../../@types/selfAssessment';
import {
  HeaderWrapper,
  SubDepartmentTitle,
} from './SelfAssessmentAssign.styled';
import { StyledSelfAssessmentContainer } from '../../../common/sharedStyledComponents/SelfAssessmentGenericStyles.styled';
import UnsavedFormDataModal from '../../../../components/commons/UnsavedFormDataModal';

type SelfAssessmentMissingFields =
  | 'Assignee'
  | 'Due Date'
  | 'Subject'
  | 'Notes';

export function SelfAssessmentAssing () {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const currentSelfAssessmentIndex: number = getItem(
    'currentSelfAssessmentIndex'
  );
  const selfAssessment: ISelfAssessmentCreation[] = getItem('selfAssessments');
  const alreadyAssignedUser = selfAssessment.flatMap(
    (assessment) => assessment.assignee.id
  );
  const isAllOptionsChecked = JSON.parse(getItem('isAllOptionsChecked'));
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
    setSearchBoxOptions,
  } = useSearchUser([], alreadyAssignedUser);

  const [isUnsavedDataModal, setShowUnsavedDataModal] = useState<boolean>(
    false
  );
  const [dueDate, setDueDate] = useState<string | Date>(
    selfAssessment[0].dueDate || ''
  );
  const [subject, setSubject] = useState<string>(
    selfAssessment[0].subject || ''
  );
  const [notes, setNotes] = useState<string>('');
  const [missingFields, setMissingFields] = useState<
    SelfAssessmentMissingFields[]
  >([]);

  const listOfDepartments = () => {
    const subDepartmentToDisplay: string[] = [];

    selfAssessment[currentSelfAssessmentIndex].departments!.map(
      (department) => {
        const subDepartmentsList: string[] = [];
        department.subDepartments.map((subDepartment) => {
          subDepartmentsList.push(subDepartment.subDepartmentName);
        });
        subDepartmentToDisplay.push(subDepartmentsList.join(', '));
      }
    );
    return subDepartmentToDisplay;
  };

  const validateAssignSelfAssessment = () => {
    const missingFieldsArray: SelfAssessmentMissingFields[] = [];
    const assignee = selectedOptions.length > 0;
    if (!subject) {
      missingFieldsArray.push('Subject');
    }
    if (!dueDate) {
      missingFieldsArray.push('Due Date');
    }
    if (!assignee) {
      missingFieldsArray.push('Assignee');
    }
    if (!notes) {
      missingFieldsArray.push('Notes');
    }
    setMissingFields(missingFieldsArray);
    return missingFieldsArray.length > 0;
  };

  function handleInputChange (value: string) {
    setSearchText(value);
    setSearchBoxOptions(filterOptions(value, searchBoxOptions));
  }

  function clearSearch () {
    setSearchText('');
    setSelectedOptions([]);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  const handleSaveAndAssignMore = () => {
    if (validateAssignSelfAssessment()) {
      return;
    }
    selfAssessment[currentSelfAssessmentIndex].assignee = selectedOptions[0];
    selfAssessment[currentSelfAssessmentIndex].dueDate = dueDate;
    selfAssessment[currentSelfAssessmentIndex].subject = subject;
    selfAssessment[currentSelfAssessmentIndex].notes = notes;
    selfAssessment[currentSelfAssessmentIndex].departments!.map((department) => {
      department.subDepartments.map((subDepartment) => {
        subDepartment.isAssignMore = true;
      });
    });
    setItem('selfAssessments', selfAssessment);
    setItem('currentSelfAssessmentIndex', currentSelfAssessmentIndex + 1);
    navigate('/selfAssessment/selectDepartments');
  };

  const finalizeHandler = () => {
    if (validateAssignSelfAssessment()) {
      return;
    }
    selfAssessment[currentSelfAssessmentIndex].assignee = selectedOptions[0];
    selfAssessment[currentSelfAssessmentIndex].dueDate = dueDate;
    selfAssessment[currentSelfAssessmentIndex].subject = subject;
    selfAssessment[currentSelfAssessmentIndex].notes = notes;
    const filteredSelfAssessment = selfAssessment.filter(sa => sa.assignee.text !== '');
    setItem('selfAssessments', filteredSelfAssessment);
    navigate('/selfAssessment/preview');
  };

  const handleBack = () => {
    selfAssessment[currentSelfAssessmentIndex].assignee = {
      id: 0,
      text: '',
    };
    selfAssessment[currentSelfAssessmentIndex].dueDate = '';
    selfAssessment[currentSelfAssessmentIndex].subject = '';
    selfAssessment[currentSelfAssessmentIndex].notes = '';
    selfAssessment[currentSelfAssessmentIndex].departments!.map((department) => {
      department.subDepartments.map((subDepartment) => {
        subDepartment.isAssignMore = false;
      });
    });
    setItem('selfAssessments', selfAssessment);
    navigate('/selfAssessment/selectDepartments');
  };

  return (
    <>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.SELF_ASSESSMENT.TITLE')}
          onClick={() => setShowUnsavedDataModal(true)}
        />
      </HeaderContainer>
      <StyledSelfAssessmentContainer>
        <Headline2>{t('COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.TITLE')}</Headline2>
        {selfAssessment &&
          selfAssessment[currentSelfAssessmentIndex].departments!.map(
            (department, index) => (
              // tslint:disable-next-line:jsx-key
              <HeaderWrapper>
                <Headline4>{department.departmentName}:</Headline4>
                <SubDepartmentTitle>
                  {listOfDepartments()[index]}
                </SubDepartmentTitle>
              </HeaderWrapper>
            )
          )}

        <InputContainer>
          <SearchBox
            handleInputChange={handleInputChange}
            searchBoxOptions={searchBoxOptions}
            handleOptionClick={handleOptionClick}
            selectedOptions={selectedOptions}
            searchTextName={searchText}
            clearSearch={clearSearch}
            placeholderText={t(
              'COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.PLACE_HOLDER.ENTER_NAME_FOR_SEARCH'
            )}
            label={t('COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.ASSIGN_TO')}
            isError={
              missingFields.length > 0 && missingFields.includes('Assignee')
            }
          />
          <DatePickerWrapper>
            <StyledTextLabel>
              <Body5 color="eerieBlack">
                {t('COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.DUE_DATE')}
              </Body5>
            </StyledTextLabel>
            <InputContainerDatePiker>
              <DatePicker
                className={`${
                  missingFields.length > 0 && missingFields.includes('Due Date')
                    ? 'myaudit-date-picker-validate-form'
                    : 'myaudit-date-picker-form'
                }`}
                popperClassName="date-picker-popper"
                dateFormat="dd-MM-yyyy"
                minDate={new Date()}
                onFocus={(event: React.ChangeEvent<HTMLInputElement>) =>
                  event.target.blur()
                }
                disabled={selfAssessment.length > 1}
                selected={
                  dueDate ? convertUTCDateDisplay(dueDate as string) : null
                }
                onChange={(selectedDate) => {
                  if (missingFields.length > 0 && selectedDate) {
                    const filteredMissingFields = missingFields.filter(
                      (field) => field !== 'Due Date'
                    );
                    setMissingFields(filteredMissingFields);
                  }
                  if (selectedDate) {
                    const date = castSelectedDateWithoutConversion(
                      selectedDate,
                      'YYYY-MM-DD'
                    );
                    setDueDate(date);
                  }
                }}
              />
              {!dueDate && (
                <CalendarIconContainer>
                  {dueDate ? (
                    <CloseCircleDark
                      onClick={() => {
                        selfAssessment[currentSelfAssessmentIndex].dueDate = '';
                      }}
                    />
                  ) : (
                    <Calendar />
                  )}
                </CalendarIconContainer>
              )}
            </InputContainerDatePiker>
            {missingFields.length > 0 && missingFields.includes('Due Date') && (
              <ErrorValidation
                message={t(
                  'COMMON.SELF_ASSESSMENT.PAGES.ERROR_MESSAGES.PLEASE_SELECT_VALID_DUE_DATE'
                )}
              />
            )}
          </DatePickerWrapper>
          <TextInput
            title={t('COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.SUBJECT')}
            textValue={subject}
            placeholder={t(
              'COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.PLACE_HOLDER.ENTER_SUBJECT'
            )}
            onValueChange={(textValue) => {
              if (missingFields.length > 0 && textValue) {
                const filteredMissingFields = missingFields.filter(
                  (field) => field !== 'Subject'
                );
                setMissingFields(filteredMissingFields);
              }
              setSubject(textValue);
            }}
            disabled={selfAssessment.length > 1}
            isError={
              missingFields.length > 0 && missingFields.includes('Subject')
            }
          />
          <TextArea
            title={t('COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.NOTES')}
            textValue={notes}
            placeholder={t(
              'COMMON.SELF_ASSESSMENT.PAGES.ASSIGN.PLACE_HOLDER.ENTER_NOTES'
            )}
            onValueChange={(textValue) => {
              if (missingFields.length > 0 && textValue) {
                const filteredMissingFields = missingFields.filter(
                  (field) => field !== 'Notes'
                );
                setMissingFields(filteredMissingFields);
              }
              setNotes(textValue);
            }}
            isError={
              missingFields.length > 0 && missingFields.includes('Notes')
            }
          />
        </InputContainer>
        <ButtonContainer>
          <ButtonBlockColumn>
            <ButtonLarge
              title={t('COMMON.SELF_ASSESSMENT.BUTTON.SAVE_AND_ASSIGN')}
              backgroundColor="oxfordBlue"
              onClick={handleSaveAndAssignMore}
              disabled={isAllOptionsChecked}
            />
            <ButtonLarge
              title={t('COMMON.SELF_ASSESSMENT.BUTTON.FINALIZE')}
              backgroundColor="verdigris"
              textColor="oxfordBlue"
              onClick={finalizeHandler}
            />
            <ButtonLarge
              outlined={true}
              inverted={true}
              title={t('COMMON.SELF_ASSESSMENT.BUTTON.BACK')}
              onClick={() => setShowUnsavedDataModal(true)}
            />
          </ButtonBlockColumn>
        </ButtonContainer>
      </StyledSelfAssessmentContainer>
      {isUnsavedDataModal && (
        <UnsavedFormDataModal
          showUnsavedDataModal={isUnsavedDataModal}
          setShowUnsavedDataModal={setShowUnsavedDataModal}
          onContinue={handleBack}
        />
      )}
    </>
  );
}
